import { produce as immerProduce } from "immer";
import { initialState } from "./state";

export function ReportState(state = initialState, action: any) {
  let data: any = null,
    payload: any;
  switch (action.type) {
      case "ORGREPORT_ACCESS_SUCCESS":
        return immerProduce(state, draft => {                
                draft.orgReportList.orgReportMappingList = action.payload.data;
                //console.log(action.payload.data)
        });
        case "REPORTSTOKEN_ACCESS_SUCCESS":
          return immerProduce(state, draft => {                
                  draft.orgReportList.accessToken = action.payload.data;
                 // console.log(action.payload.data)
          });      
              
    default:
      return state;
  }
}
